var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "column_add",
    "data-name": "Add column",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #column_add path, #column_add rect {\r\n        stroke-width: 0px;\r\n        fill: currentColor;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.48,22.62h-3.83c-.9,0-1.62-.73-1.62-1.62V7.01c0-.9.73-1.62,1.62-1.62h3.83c.9,0,1.62.73,1.62,1.62v13.99c0,.89-.73,1.62-1.62,1.62ZM7.02,20.62h3.08V7.38h-3.08v13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.56,22.62h-3.83c-.9,0-1.62-.73-1.62-1.62V7.01c0-.9.73-1.62,1.62-1.62h3.83c.9,0,1.62.73,1.62,1.62v13.99c0,.89-.73,1.62-1.62,1.62ZM12.1,20.62h3.08V7.38h-3.08v13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.65,22.62h-3.83c-.9,0-1.62-.73-1.62-1.62V7.01c0-.9.73-1.62,1.62-1.62h3.83c.9,0,1.62.73,1.62,1.62v1.21h-2v-.84h-3.08v13.24h3.08v-1.17h2v1.55c0,.89-.73,1.62-1.62,1.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.26,
    y: 11.21,
    width: 2,
    height: 5.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.47,
    y: 13,
    width: 5.58,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnAdd);
export default __webpack_public_path__ + "static/media/columnAdd.e8e6219b6b42cc04a0a25aed371891b2.svg";
export { ForwardRef as ReactComponent };